import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyvaluePipe } from './keyvalue.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [KeyvaluePipe],
  exports: [ KeyvaluePipe ]
})
export class KeyvalueModule { }



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/keyvalue/keyvalue.module.ts